import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type RouteRecordRaw } from 'vue-router';

import FavouritesPage from '@/pages/FavouritesPage.vue';
import routePaths from '@/router/routes.json';

const favouritesPageRoutes: RouteRecordRaw[] = Object.entries(routePaths).map(
  ([locale, routeItem]) => ({
    path: `/${(routeItem as any).favourites.path}`,
    name: `favouritesPage-${locale}`,
    component: FavouritesPage,
    meta: {
      locale,
      getLanguageSwitchLink(route: any, language: HgSupportedLanguage) {
        return {
          name: `favouritesPage-${language}`,
          query: route.query,
          params: route.params,
        };
      },
      viewName: 'Favourites Page',
    },
  }),
);

export default favouritesPageRoutes;
